export enum CashDiscountType {
    Net = 1,
    Gross = 2,
}
